import { inject } from '@angular/core';
import { ApiServerService, EmptyResponse } from '../../core/api';

const baseUrl = 'users';

export const injectUserApi = () => {
  const service = inject(ApiServerService);
  return {
    /** Envia email de recuperacion de password usando plantilla custom del servidor. */
    passwordResetEmail: (request: UserPasswordResetEmailRequest): Promise<UserPasswordResetEmailResponse> => {
      const path = `${baseUrl}/passwordResetEmail`;
      return service.call<UserPasswordResetEmailResponse, UserPasswordResetEmailRequest>(path, request);
    }
  };
};

export interface UserPasswordResetEmailRequest {
  email: string;
}

export type UserPasswordResetEmailResponse = EmptyResponse;

